module.exports = __webpack_public_path__ + "img/vip_recharge.8c94640f.png";